<template>
  <div class="page-box">
    <div class="topbar" :class="scrollClass">
      <div class="logo-box">
        <img src="@/assets/img/2023default/index/logo.png" class="logo" alt="" >
      </div>
      <div class="topbar-right" @click="goMerchant()">
        <img src="@/assets/img/2023default/index/user.png" class="user" alt="">
        <div>登录</div>
      </div>
    </div>
    <el-carousel height="430px">
      <el-carousel-item v-for="item in 1" :key="item">
        <img src="@/assets/img/2023default/index/banner.png" class="banner" alt="">
      </el-carousel-item>
    </el-carousel>
    <div class="action_box">
      <div class="action_box-item" @click="orderSearch">
        <div class="left">
          <div class="action_name">
            订单查询
          </div>
          <div class="action_btn">
            查看详情<i class="el-icon-arrow-right" style="margin-left: 4px;"></i>
          </div>
        </div>
        <div class="right">
          <img src="@/assets/img/2023default/index/search.png" width="80rpx" height="80rpx" alt="aspectFit">
        </div>
      </div>
      <div class="action_box-item" @click="orderComplain">
        <div class="left" >
          <div class="action_name">
            投诉查询
          </div>
          <div class="action_btn">
            查看详情<i class="el-icon-arrow-right" style="margin-left: 4px;"></i>
          </div>
        </div>
        <div class="right">
          <img src="@/assets/img/2023default/index/complate.png" width="80rpx" height="80rpx" alt="aspectFit">
        </div>
      </div>
    </div>
    <div class="news_box mb-10">
        <div class="section-title">平台资讯</div>
        <div class="button-box">

            <div @click="switchCate(item.id)" v-for="(item,index) in cateList" :key="index" class="button-box-item " :class="index === currentCate ? 'active':''">
              {{item.name}}
            </div>
        </div>
        <div class="content-box">
          <div v-if="newsNum === 0" >
            <div style="padding: 20px; text-align: center; color: #999999">暂无相关资讯</div>
          </div>
          <div v-else class="content-box-item" v-for="(item,index) in newsList" :key="index" @click="showContent(item)">
              <div class="content-box-info">
                <div class="content-title">
                  {{item.title}}
                </div>
                <div class="content-publish">
                  {{item.addtime}}
                </div>
              </div>
              <div class="content-box-img">

                <img :src="getImge(index)" style="">
              </div>
          </div>
        </div>
    </div>
    <div class="section-box mb-10">
      <div class="section-title">风控中心</div>
      <div class="fk-box">
        <div class="fk-box-item">
          <div>累计风控次数</div>
          <div class="blue">120214</div>
        </div>
        <div class="fk-box-item">
          <div>今日风控次数</div>
          <div class="blue">120214</div>
        </div>
        <div class="fk-box-item">
          <div>累计订单投诉率</div>
          <div class="red">5.00%</div>
        </div>
        <div class="fk-box-item">
          <div>今日订单投诉率</div>
          <div class="red">5%</div>
        </div>
        <div class="icon">
          <img src="@/assets/img/2023default/index/fk.png" />
        </div>
      </div>
    </div>
    <div class="section-box">
      <div class="section-title">官方售后</div>
      <div class="customer-box">
        <div class="customer-box-item">服务时间：08:30~23:00</div>
        <div class="customer-box-item">友情链接：寄居蟹寄售商城平台</div>
        <div class="customer-box-item">客服电话：19905590560</div>
        <div class="customer-box-item qrcode-box">
          <div class="qrcode-box-item">
            <img src="@/assets/img/default/wx_kefu.png" mode="aspectFit"  alt=""/>
            <div >
              客服QQ
            </div>
          </div>
          <div  class="qrcode-box-item">
            <img src="@/assets/img/default/wx_kefu.png" mode="aspectFit"  alt=""/>
            <div >
              客服微信
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="copyright">
        Copyright@2023AIl Rights Reserved.2023
      </div>
      <div class="copyright">
        上海企传数字科技有限公司
      </div>
      <div class="copyright">
        工信部ICP备案:沪CP备2022034534号-1
      </div>
      <div class="copyright">
        增值电信许可证 沪B2-20230251
      </div>
      <div class="copyright">
        <a style="margin-top: 8px" target="_blank" :href="domianList[domianIndex].value"><img src="@/assets/img/default/lz2.jpg" style="width: 30px;"></a>
      </div>
    </div>
    <el-dialog :title="newsInfo.className"  center custom-class="gonggao" width="90%" :visible.sync="dialogTableVisible" >
      <div class="gg-box">
        <div v-html="newsInfo.title" class="gg-title"></div>
        <div v-html="newsInfo.content" class="gg-content"></div>
        <div class="gg-addtime">
          发布时间：{{newsInfo.addtime}}
        </div>
      </div>

    </el-dialog>
  </div>
</template>
<script>
import { getCate } from "@/api/newsCate"
import { getListByCate } from "@/api/news"
import mergeImage from '@/assets/img/2023default/index/mergeImage.png'
import mergeImageO from '@/assets/img/2023default/index/mergeImage_1.png'
import mergeImageT from '@/assets/img/2023default/index/mergeImage_2.png'
export default {
  name: 'IndexDefault',
  data () {
    return {
      domianList:[
        {
          name:"www.jijuxjs.com",
          value:"https://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020221110144517000009794966-SAIC_SHOW_310000-2c984b428a0650a9018a24e27a0f35d9793&signData=MEUCIQCJIru58wqrKkKeTnuTsHObu//zqF+ZpafKkjDq2p9oUQIgWvrZhfUZtGtmX7dzyi2oLuthHn6u3vxjtFPZ/wdvxO0="
        },
        {
          name:"www.jjxdw.cn",
          value:"https://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020221110144517000009794966-SAIC_SHOW_310000-2c984b428a0650a9018a24e27a0f35dd113&signData=MEQCIACkEDNBp+ca27bZTz91umFE2PhDz/lPet/HEjDgVvQhAiAZRjBfxqXjpsNWqsyWA8wSGuVOoLEaMvrr41D24r2/WA=="
        },
        {
          name:"www.jijuxjs.cn",
          value:"https://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020221110144517000009794966-SAIC_SHOW_310000-2c984b428a0650a9018a24e27a0f35db661&signData=MEUCIQDCL+wifSSBYU6Z3QDjEltDsdkxWBUpaOv/WXrpnW6hAgIgDw8LTYZ1bqxM9p9eFeA6m5C9uXe92NUJHTfpptsDTlw="
        }
      ],
      domianIndex:0,
      dialogTableVisible:false,
      scrollClass:'',
      scrollTop: 0,
      btnFlag: false,
      merchantUrl: 'http://jijuxjs.com/merchant/login',
      cateList:[],
      imgList:[
        {
          url:mergeImage
        },
        {
          url:mergeImageO
        },
        {
          url:mergeImageT
        }
      ],
      currentCate:0,
      newsInfo:{},
      newsList:[],
      newsNum:0
    }
  },
  created () {
    this.getCateList()
    this.getDomian()
  },
  mounted () {
    window.addEventListener('scroll', this.scrollToTop)
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    getDomian(){
      const currentHost = window.location.host;
      console.log(currentHost)
      this.domianIndex=this.domianList.findIndex(item=>item.name===currentHost)>=0?this.domianList.findIndex(item=>item.name===currentHost):0;
      console.log(this.domianIndex)
    },
    getImge ( index ) {
      console.log(index)
      let idx=index%3
      return this.imgList[idx].url
    },
    showContent(item){
      this.newsInfo=item
      this.dialogTableVisible=!this.dialogTableVisible
    },
    switchCate(id){
      let index =this.cateList.findIndex((item)=>item.id === id)
      this.currentCate=index
      this.getNewsList()
    },
    //获取分类
    async getCateList () {
      await getCate(1, 4).then((res)=>{
            if(res.data.total>0){
              let catelist= res.data.list.filter(item => item.name !== "结算公告")
              console.log(catelist)

              this.cateList=catelist;
            }

       })
       this.getNewsList()
     },
    //获取新闻
    getNewsList(){
      this.newsList=[]
      this.newsNum=0
      getListByCate(1, 5 , this.cateList[this.currentCate].id ).then((res)=>{
        this.newsList=res.data.list;
        this.newsNum=res.data.total
      })
    },
    goMerchant(){
      window.location.href = 'https://jijuxjs.com/merchant/login';
    },
    orderSearch(){
      console.log("订单查询")
      this.$router.push("/orderSearch")
    },
    orderComplain(){
      console.log("投诉查询")
      this.$router.push("/complainSearch")
    },
    scrollToTop () {
      const that = this
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      that.scrollTop = scrollTop
      if (that.scrollTop > 0) {
        that.scrollClass = 'topbar-active'
      } else {
        that.scrollClass = ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page-box{
  background: #F8F8F8;
  min-height: 100vh;
  .gonggao{
    .el-dialog__body{
      padding-bottom: 12px !important;
    }
  }
  .gg-box{
    .gg-title{
      color: #000;
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 12px;
      border-bottom: 1px solid #999999;
    }
    .gg-content{
      padding: 12px 0;
      border-bottom: 1px solid #999999;
    }
    .gg-addtime{
      padding: 12px 0 0;
    }
  }
  .mb-10{
    margin-bottom: 8px;
  }
  .topbar{
    position: fixed;
    top:0px;
    width: 100%;
    z-index: 999;
    display: flex;
    justify-content: space-between;
    padding: 20px 10px;
    .logo-box{
      .logo{
        width: 83px;
        height: 26px;
      }
    }
    .topbar-right{
      display: flex;
      height: 26px;
      line-height: 26px;
      view{
        margin-left: 3px;
        color: #fff;
      }
    }
  }
  .topbar-active{
    background: #2C8BFF;
  }
  .banner{
    width: 100%;
    height: 430px;
  }
  .action_box{
    margin: 12px;
    display: flex;
    justify-content: space-between;
    .action_box-item{
      border-radius: 5px;
      background: #fff;
      width: 170px;
      height: 86px;
      padding: 5px 0 5px 10px;
      display: flex;
      justify-content: space-between;
      .left{
        display: flex;
        justify-content: center;
        flex-direction: column;
        .action_name{
          color: #000;
          font-size: 15px;
          font-weight: bold;
        }
        .action_btn{
          display: flex;
          justify-content: center;
          color: #000;
          font-size: 12px;
          margin-top: 10px;
        }
      }
      .right{
        display: flex;
        justify-content: center;
        flex-direction: column;
      }

    }
  }
  .section-title{
    color: #000;
    font-weight: bold;
    position: relative;
    text-indent: 10px;
    font-size: 16px;
  }
  .section-title::after{
    content: "";
    position: absolute;
    left: 0;
    top: 4px;
    width: 4px;
    height: 16px;
    background: #0066FF;
    border-radius: 2px;
  }
  .news_box{
    padding: 12px;
    background: #fff;
    .button-box{
      display: flex;
      padding: 10px 0;
      .button-box-item{
        padding: 6px 15px;
        background:#F0F0F0;
        color: #999999;
        border-radius: 5px;
        margin-right: 10px;
      }
      .active{
        background: #0066FF;
        color: #fff;
      }
    }
    .content-box{
      padding:12px 6px;
        .content-box-item{
          padding: 15px 0;
          border-bottom: 1px solid #F0F0F0;
          display: flex;
          justify-content: space-between;
          .content-box-info{
            width: 66%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .content-title{
              font-size: 15px;
              font-weight: 500;
              color: #333333;
              line-height: 18px;
            }
            .content-publish{
              font-size: 13px;
              font-weight: 400;
              color: #999999;
              line-height: 18px;
            }
          }
          .content-box-img{
            width: 30%;
            img{
              width: 108px;
              height: 81px;
            }

          }
        }
    }
  }
  .section-box{
    padding: 12px;
    background: #fff;
    color: #333333;
  }
  .fk-box{
    margin-top: 16px;
    padding: 12px;
    display: flex;
    flex-wrap:wrap;
    background: #F6F8FF;
    border-radius: 8px;
    position: relative;
    .fk-box-item{
      flex: 1;
      min-width: 50%;
      margin-bottom: 15px;
      padding-left: 6px;
      div{
        color: #333333;
        font-size: 14px;
        font-weight: bold;
        padding-top: 4px;
        padding-left: 4px;
      }
      .blue{
        font-size: 18px;
        color: #0066FF;
      }
      .red{
        font-size: 18px;
        color: #FF3000;
      }
    }
    .icon{
      position: absolute;
      top: 0;
      right: 0;
      img{
        width: 48px;
        height: 37px;
      }
    }
  }
  .customer-box{
    padding: 15px 4px;
    .customer-box-item{
      height: 35px;
      line-height: 35px;
      padding-left: 19px;
      background: #F6F8FF;
      margin-bottom: 11px;
      border-radius: 3px;
      color: #333333;
      font-weight: 400;
    }
    .qrcode-box{
      display: flex;
      padding: 12px;
      height: auto !important;
      .qrcode-box-item{
        text-align: center;
        line-height: initial!important;
        img{
          width: 88px;
          height: 88px;
        }
      }

    }
  }
  .footer{
    background: #3F404D;
    padding: 14px 8px;
    .copyright{
      color: #FFFFFF;
      font-size: 10px;
      line-height: 14px;
      height: 14px;
      margin-bottom: 8px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/2023default/index.vue